import type { Auth } from 'firebase/auth'

type AuthModule = typeof import('firebase/auth')

export interface AuthClient {
  auth: Auth
  mod: AuthModule
}

let loader: Promise<AuthClient> | null = null

// Lazy entry point for firebase/auth used by AuthContext (which is in the
// initial bundle on every page). Route chunks that need the instance
// synchronously import { auth } from './auth' directly; Rollup shares the
// chunk between the two paths.
export function loadAuth(): Promise<AuthClient> {
  if (!loader) {
    loader = Promise.all([import('./auth'), import('firebase/auth')]).then(
      ([authModule, mod]) => ({ auth: authModule.auth, mod }),
    )
  }
  return loader
}
